import { useHistory } from "react-router-dom";

import useMountEffect from "../../../../Components/hooks/useMountEffect";

const Fsk8sPageRedirect = () => {
  const history = useHistory();
  useMountEffect(() => {
    window.open("https://app.perfectscale.io/account/sign-up", "_blank", "noopener");
  });
  history.goBack();
  return null;
};

export default Fsk8sPageRedirect;
